import './App.css';
import React from 'react'
import { Route, Routes, Navigate } from "react-router-dom"
import HomePage from './components/PageComponents/HomePage.jsx'
import TeamPage from './components/PageComponents/TeamPage.jsx'
import PageHeader from './components/PageComponents/PageHeader.jsx'
import PageFooter from './components/PageComponents/PageFooter.jsx'
import BugKing from './components/PageComponents/BugKing.jsx'
import RestoApp from './components/PageComponents/RestoApp.jsx'
import VoiceChatPage from './components/PageComponents/VoiceChatPage.jsx';
import AnivPage from './components/PageComponents/AnivPage.jsx';

function App() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>

      <div>
        <Routes>
          <Route path='/' element={<Navigate to='/cm' replace />} />
          <Route path='/cm' element={
            <>
              <PageHeader />
              <HomePage />
              <PageFooter />
            </>
          } />
          <Route path='/cm/team' element={
            <>
              <PageHeader />
              <TeamPage />
              <PageFooter />
            </>
          } />
          <Route path='/signals/bugking' element={<BugKing />} />
          <Route path='/beans/resto_app' element={<RestoApp />} />
          <Route path='/at/vc' element={<VoiceChatPage />} />
          <Route path='/at/aniv5m'element={<AnivPage />} />
          <Route path='*' element={<div>Hey look, nothing!</div>} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
